import { FC } from 'react';
import { IonAvatar } from '@ionic/react';
import { IFamilyMember } from '../caremap/ICareMap';
import { EditIcon2 } from '../theme/Icons';
import { HOUSEHOLD_MEMBER_AVATARS } from '../caremap/CareMapFactory';

export const MemberAvatar: FC<{
    member: Partial<IFamilyMember>;
    small?: boolean;
    xsmall?: boolean;
    // explicit pixel diameter; overrides the small/xsmall presets when set
    size?: number;
    onClick?: (e: React.MouseEvent) => void;
}> = ({ member, small = false, xsmall = false, size: sizeOverride, onClick }) => {
    const imageUrl = member.photo || member.avatar || (!member.color ? HOUSEHOLD_MEMBER_AVATARS[0] : undefined);
    const dim = sizeOverride ?? (xsmall ? 32 : small ? 42 : 64);
    const size = {width: dim, height: dim };

    const avatar = (
        <IonAvatar style={{ ...size, backgroundColor: member.color }} data-avatar={imageUrl || member.color}>
            {imageUrl &&
                <div style={{
                    width: '100%',
                    height: '100%',
                    borderRadius: '50%',
                    backgroundImage: `url("${imageUrl}")`,
                    // TODO: better way to set these up / scale / position them, based on our "profile image" effort in the future
                    position: 'relative',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: '75% 40%'
                }}></div>
            }
        </IonAvatar>
    );

    if (onClick) {
        return (
            <div style={{ cursor: 'pointer', position: 'relative'}} onClick={(e: React.MouseEvent) => onClick(e)}>
                {avatar}
                <div style={{ position: 'absolute', bottom: -2, right: -2 }}>
                    <EditIcon2 size="small" shape="round" backgroundColor="white" borderColor="medium" />
                </div>
            </div>
        );
    }
    else {
        return avatar;
    }
};
